import React, {useState} from 'react';
import {handleInputChange} from "src/components/form/formHandler";
import {IconButton, InputAdornment, TextField} from "@mui/material";
import {Visibility, VisibilityOff} from "@mui/icons-material";

const PasswordField = (props) => {
    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = () => {
        setShowPassword(prevState => !prevState);
    }

  return (
    <TextField
      {...props}
      type={showPassword ? 'text' : 'password'}
      InputProps={{ // <-- This is where the toggle button is added.
          endAdornment: (
            <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
            </InputAdornment>
          )
      }}
    />
  );
}

export default PasswordField;

PasswordField.propTypes = {};

PasswordField.defaultProps = {};
